"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyCopy = void 0;
exports.SurveyCopy = {
    surveyName: 'How was your recent visit?',
    introMessage: `Thank you for choosing us as your pet's healthcare provider! We truly appreciate the trust you've placed in us for {{petName}}'s care. Would you mind taking a moment to complete a brief survey about your visit? Your feedback helps us continue to improve and provide the best care possible.`,
    ratingQuestion: 'Overall, how would you rate your most recent experience with {{clinicName}}?',
    positiveQuestion: 'Tell us what you liked about your experience',
    negativeQuestion: 'What could we have done to make your experience better?',
};
//# sourceMappingURL=defaultSurveyCopy.js.map